import React, { useState } from "react";
import TopComponent from "../DMCA/TopComponent";
import RightComponent from "../DMCA/RightComponent";
import BottomComponent from "../DMCA/BottomComponent";
import "./ReviewPolicy.scss";
import { AiOutlinePlus, AiOutlineMinus } from "react-icons/ai";

const ReviewPolicy = () => {
  const [faqs, setFaqs] = useState();
  const privacyPolicy = [
    { heading: "Duplicate Ad listings", detail: "Any ad posted more than once with the same content or Title in the same city and category would be considered as a Duplicate Ad.", idx: "1" },
    { heading: "Spamming is Forbidden", detail: "Spamming is Forbidden as posting similar Ads indiscriminately in Bulk is not allowed.", idx: "2" },
    { heading: "Inappropriate Content", detail: "Do not use Irrelevant/gibberish/vague Titles or Description", idx: "3" },
    { heading: "Special character(s)", detail: "Special character(s) and can,t understandable characters are banned.", idx: "4" },
    { heading: "Links to other Websites", detail: "Links to other Websites are not allowed in description, Social Media and/or email addresses are not allowed in description", idx: "5" },
    { heading: "Only Verified emails can be mentioned", detail: "Only Verified emails can be mentioned. Non-registered emails are not allowed in title, description or in image.", idx: "6" },
    {
      heading: "Inappropriate Picture",
      detail: "Inappropriate Picture: Do not include obscene, fake or human images. Kindly note, an account can also be blocked depending upon the severity of the case.",
      idx: "7",
    },
    {
      heading: "Stock/Internet Images",
      detail: "Stock/Internet Images: Ads having fake, generic and competitor images are not permitted. We advise you to post real images of the item for sale.",
      idx: "8",
    },
    {
      heading: "Sexually oriented material",
      detail:
        "Sexually oriented material: Ads relating to products intended for use in sexual activity are not permitted. Also, refrain from using a title with graphic adult language, regardless of the item.",
      idx: "9",
    },
    {
      heading: "Local posting",
      detail:
        "Local posting: All offerings to be in Pakistan. Ads posted using foreign IP(s) or containing foreign number(s) are not permitted. Importantly, an account should only correspond to one phone number. Multiple phone numbers are strictly prohibited. Competitor Ads are not allowed.",
      idx: "10",
    },
    { heading: "Misleading Item/Service", detail: "Misleading Item/Service: Misrepresentation of Ad offer/content is not permitted.", idx: "11" },
    {
      heading: "Multiple Products",
      detail:
        "Multiple Products: Selling multiple items or service is not allowed in an Ad. Please post a new Ad for every item/service with proper Title, good Description, appropriate Price & clear Pictures.",
      idx: "12",
    },
    { heading: "Individual Financing", detail: "Individual Financing: Financing is not allowed unless represented by a Reputable / Registered Financial Institution or Organization.", idx: "13" },
    { heading: "Change of Product", detail: "Change of Product: Changing Item or Service after posting an Ad is not allowed. Please post a new Ad.", idx: "15" },
    { heading: "Purchase Ads", detail: "Purchase Ads: Posting Ads for purchase purposes is not allowed.", idx: "16" },
    {
      heading: "Addition of new Product",
      detail:
        "Addition of new Product: After posting an Ad, it is not allowed to add new Item or Service. Kindly post a new Ad with proper Title, good Description, appropriate Price & clear pictures.",
      idx: "17",
    },
    { heading: "Advance payment", detail: "Advance payment: CityBook strives very hard to maintain a safe and secure community. Any kind of advance payment is prohibited.", idx: "18" },
    { heading: "Wildlife", detail: "Wildlife: CityBook allows only those Animals which are in accordance to the Provincial Wildlife Regulations.", idx: "19" },
  ];
  return (
    <>
      <TopComponent />
      <div className="container">
        <div className="row">
          <RightComponent />
          <div className="col-sm-8">
            <div>
              <h1>Review Policy</h1>
              <div className="mt-2">
                {privacyPolicy.map((item, i) => (
                  <div key={i}>
                    <div className="d-flex justify-content-between border-bottom py-3" style={{ cursor: "pointer" }} onClick={() => setFaqs(item.idx)}>
                      <h4 className="mb-0 align-self-center">{item.heading}</h4>
                      <div className="align-self-center">{faqs === item.idx ? <AiOutlineMinus /> : <AiOutlinePlus />}</div>
                    </div>
                    {faqs === item.idx ? (
                      <div className="mt-3">
                        <p>{item.detail}</p>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <BottomComponent />
    </>
  );
};

export default ReviewPolicy;
